import React from 'react'
import Layout from './Layout'
// import Home from './Home'
import NotFound from './Misc/NotFound'
import Auth from './Auth'
import Settings from './Settings'
import Documents from './Documents'
import SignMain from './Sign/Main'
import SignLayout from './Sign/Layout'
import Templates from './Templates'
import Organizations from './Organizations'
import DocumentVerify from './DocumentVerify'
import PubDocumentVerify from './PubDocumentVerify'
import Createorganization from './Createorganization'
import Sign from './Sign'
import {Route, IndexRoute} from 'react-router'
import Accept from './Organizations/Accept'
import Admin from './Admin'
import Custom from './Custom'
import Preparation from './Preparation'
import Payment from './Payment'
import Public from './Public'

export default (
  <Route>
    {Auth}
    {Public}
    <Route component={Layout}>
      <Route path="/" component={SignLayout}>
        <IndexRoute component={SignMain} />
      </Route>
      <Route path="accept/:memberId" component={Accept} />
      {Settings}
      {Sign}
      {Admin}
      {Custom}
      {Preparation}
      {Documents}
      {Templates}
      {DocumentVerify}
      {Organizations}
      {Createorganization}
      {Payment}
    </Route>
    {PubDocumentVerify}
    <Route path="*" component={NotFound} />
  </Route>
)



// WEBPACK FOOTER //
// ./src/App/Pages/index.js